export const pt = {
    "TRIGGER_LISTEN": "Ouvindo por gatilhos",
    "ASSIST_EMPTY_MSG": "O agente AI está ouvindo sua conversa e pronto para ajudar automaticamente quando acionado.",
    "MYBOT_TRIGGET_LISTEN": "Nenhuma tarefa ativa do Meu Bot no momento",
    "MYBOT_EMTPY_MSG": "Para iniciar uma tarefa no Meu Bot, vá para a aba de busca e selecione a opção \"Executar com entradas do agente\" para a tarefa desejada.",
    "PROACTIVE_MODE": "Modo Proativo",
    "SETTINGS": "Configurações",
    "HELP_AND_SUPPORT": "Ajuda e Suporte",
    "HELP": "Ajuda",
    "LANGUAGE": "Idioma",
    "THEME": "Tema",
    "FILE_NAME":"Nome do arquivo",
    "AUTOMATIC": "Automático",
    "DARK": "Escuro",
    "AUTO_SCROLL_TOOLTIP":"Controla a rolagem automática da guia Assistência, Meu bot e conteúdos da guia Transcrição",
    "LIGHT": "Claro",
    "THEME_DESC": "Isto usará o modo padrão do seu sistema",
    "DOCUMENTATION": "Documentação",
    "DOC_DESC": "Confira nossos artigos de documentação aprofundada.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Confira as perguntas frequentes sobre o Agent AI.",
    "KORE_ACADEMY": "Academia Kore",
    "KORE_ACA_DESC": "Aprenda mais sobre o Agent AI através dos cursos da academia.",
    "SEARCH": "Buscar",
    "TAB_TEXT":"Nenhuma guia ativada! Ative pelo menos uma guia",
    "MY_BOT": "Meu Bot",
    "ASSIST": "Assistir",
    "TRANSCRIPT": "Transcrição",
    "HISTORY": "Histórico",
    "STARTOVER": "Reiniciar",
    "TAP_SEARCH":"Toque para pesquisar",
    "RESTART_INPUTS": "Reiniciar com entradas capturadas",
    "ASKCUSTOMER": "Pergunte ao Cliente",
    "TELLCUSTOMER": "Diga ao Cliente",
    "WELCOME_MSG": "Mensagem de Boas-vindas",
    "SEND": "Enviar",
    "SENT": "Enviado",
    "AWAITING": "Aguardando Resposta | Digite para continuar",
    "OVERRIDE": "Digite para continuar",
    "OVERRIDE_FILE": "Anexe um arquivo para continuar",
    "ACCEPT_RESPONSE": "Resposta Aceita",
    "AGENT_ENTERED": "Agente Entrou",
    "EXPECTED_FORMAT": "Formato Esperado",
    "INPUT_VALUES": "Valores de Entrada",
    "RESTART": "Reiniciar",
    "START_OVER": "Reiniciar",
    "RESTART_CAPTURE": "Reiniciar com entradas capturadas",
    "CANCEL": "Cancelar",
    "INTERRUPT_DIALOG": "TAREFA DE DIÁLOGO INTERROMPIDO",
    "RUN": "EXECUTAR",
    "RUN_AGENT": "Executar com entrada do agente",
    "STEP": "Passo",
    "DIALOG_TASK": "Tarefa de Diálogo",
    "FAQ": "FAQ",
    "SNIPPET": "Respostas",
    "ARTICLE": "Páginas da Web",
    "FILE": "Arquivos",
    "SUGGESTED": "Sugerido",
    "ALL_DIALOG": "Todas as Tarefas de Diálogo",
    "DIALOG_TEXT": "Diálogo",
    "INTENT_IDENTIFIED": "Enunciado do cliente",
    "NOT_WHAT_LOOKING": "Sugestão Errada?",
    "BOT": "Bot",
    "CUSTOMER": "Cliente",
    "YOU": "Você",
    "TERMINATE_CONV": "Terminar Tarefa de Diálogo",
    "TERMINATE_CONV_DESC": "Tem certeza de que deseja terminar a tarefa de diálogo? O Agent AI não poderá fazer mais sugestões.",
    "YES_TERMINATE": "Sim, Terminar",
    "NO_CANCEL": "Não, Cancelar",
    "OVERRIDE_CONTINUE": "Continuar com o modo de sobreposição",
    "SUMMARY_TEXT": "Resumo",
    "SUBMIT": "Enviar",
    "INTERRUPT_OCCURED": "Interrupção Ocorreu",
    "IDENTIFIED_INTENT": "Intenção Identificada",
    "INTERRUPT_DESC": "Executar isso encerrará sua Tarefa de Diálogo em andamento.",
    "ACCEPT_RUN": "Aceitar e Executar",
    "RUN_LATER": "Executar Depois",
    "KNOW_MORE": "Saber Mais",
    "MORE_TEXT": "Mais",
    "LESS_TEXT": "Menos",
    "VIEW_MORE": "Ver Mais",
    "VIEW_LESS": "Ver Menos",
    "SHOW_MORE_FAQ": "Mostrar mais FAQs",
    "SHOW_LESS_FAQ": "Mostrar menos FAQs",
    "SHOW_MORE_ARTICLE": "Mostrar mais páginas da web",
    "SHOW_LESS_ARTICLE": "Mostrar menos páginas da web",
    "SHOW_MORE_SNIPPET": "Mostrar mais Respostas",
    "SHOW_LESS_SNIPPET": "Mostrar menos Respostas",
    "SHOW_MORE_FILES": "Mostrar Mais Arquivos",
    "SHOW_LESS_FILES": "Mostrar Menos Arquivos",
    "VIEW_ALL_DIALOG": "Ver todos os Diálogos",
    "VIEW_FEW_DIALOG": "Ver alguns Diálogos",
    "HELP_FULL": "Útil?",
    "THANKYOU": "Obrigado!",
    "EXPAND_MORE": "Expandir / Mais",
    "CLOSE_TEXT": "Fechar",
    "STARTED": "Iniciado",
    "ENDED": "terminado",
    "VIEW_FULL_ARTICLE": "Ver página da web",
    "VIEW_FULL_FILE": "Ver arquivo",
    "COPIED": "Copiado",
    "SENTI_ANALY": "Análise de Sentimento",
    "WRONG_SUGGESTION": "Sugestões Erradas",
    "INCORRECT_INTENT": "Intenção Incorreta",
    "ACCIDENTAL_CLICK": "Clique Acidental",
    "TIME_TAKING": "Levando Tempo",
    "OTHER": "Outro",
    "PLAYBOOK_EMPTY_MSG": "Selecione o Playbook",
    "PLAYBOOK_EMPTY_DESC": "O agente AI não consegue carregar o playbook porque todos os playbooks disponíveis são dinâmicos. Clique em 'Selecionar Playbook' para acessar o playbook",
    "STAGE": "Fase",
    "PROCEED_TO_CLOSE": "Prosseguir para fechar",
    "RECOMENDED_PLAYBOOK": "PLAYBOOK RECOMENDADO",
    "PRIMARY_SCRIPTS": "ROTEIROS PRINCIPAIS",
    "DYNAMIC_SCRIPTS": "ROTEIROS DINÂMICOS",
    "RESUME": "Retomar",
    "ENABLE_CLOSE": "Clique no botão prosseguir para fechar para habilitar a fase de fechamento",
    "LIST_VIEW": "Visualização em Lista",
    "TERMINATE": "Terminar",
    "MINIMIZE": "Minimizar",
    "MAXIMIZE": "Maximizar",
    "NO_SEARCH_RESULT": "Nenhum resultado de pesquisa encontrado",
    "SENTIMENT_AWAITING": "Aguardando sentimento",
    "POSITIVE": "Pos",
    "NEGATIVE": "Neg",
    "ASSOCIATED_WORK_NOTES": "Notas de Resolução Passadas",
    "AGENT_JOINED_CONV": "Agente entrou na conversa",
    "AUTOSCROLL_ASSIST": "Auto-Rolar Conteúdo da Aba de Assistência",
    "FILE_SIZE_MSG": "O tamanho do arquivo deve ser de até 25MB. Por favor, tente novamente.",
    "OVERRIDE_BTN": "Substituir",
    "CHOOSE_FILE": "Escolha um Arquivo",
    "SUMMARY_ERROR_TEXT": "Desculpe, mas houve um problema ao gerar o resumo desta conversa. Por favor, crie seu próprio resumo.",
    "ASK_A_QUESTION": "Faça uma pergunta",
    "COPY": "Copiar",
    "TELL_US_MORE": "Conte-nos mais…",
    "THANKS_FEEDBACK": "Obrigado pelo seu feedback",
    "SOMETHING_WRONG": "Algo deu errado",
    "CLICK_ERROR_DETAILS": "Clique para ver os detalhes do erro",
    "NO_ACTIVE_PLAYBOOK": "Nenhum playbook ativo",
    "REPHRASE_QUESTION": "Você pode reformular sua pergunta ou perguntar algo diferente?",
    "VIEW_FULL_ARTICLE_2": "Ver o artigo completo",
    "VIEW_FULL_FILE_2": "Ver o arquivo completo",
    "INTERNAL_INFO": "Informações internas",
    "PLAYBOOK": "Playbook",
    "SOURCES": "Fontes",
    "CONVERSATION_SUMMARY": "Resumo da conversa",
    "WAITING": "Aguardando",
    "WIDGET_DISABLED": "Widget desativado",
    "AI_SETTINGS_DISABLED": "Configurações de IA desativadas! Entre em contato com o administrador de IA",
    "SERVER_CONNECTION_ERROR": "Erro ao conectar ao servidor",
    "VIEW": "Ver",
    "ATTACHMENT_INPUT": "Entrada de anexo",
    "TYPE_SUMMARY": "Digite o resumo",
    "BY":"Por",
    GENERATE_SUMMARY: "Gerar resumo",
    PREV_SUMMARIES: "Sumários gerados anteriormente",
    DIALOG_WORKFLOWS: "Fluxos de trabalho de diálogo",
    SHOW_ALL_DIALOG: "Mostrar todas as tarefas de diálogo",
    SHOW_ALL_DIALOGS: "Mostrar todos os diálogos",
    CUSTOM_TAB: "Guia personalizada",
    AGENT_INPUT: "Entrada do agente",
    "CUSTOM_EMPTY_MSG" : "Nenhum fluxo de trabalho ativo",
    "CUSTOM_TAB_DESC" : "Para iniciar um fluxo de trabalho, execute um dos itens da lista presente na parte inferior da tela.",
    "SUBMIT_OVERALL_FEEDBACK" : "Enviar feedback geral",
    "FEEDBACK_POPUP_SUBTITLE" : "Feedback sobre o widget e suas funcionalidades",
    "FEEDBACK_SATISFIED" : "Satisfeito",
    "FEEDBACK_UNSATISFIED" : "Insatisfeito",
    "FEEDBACK_PROVIDE_REASONS" : "Fornecer razões",
    "FEEDBACK_TITLE" : "Feedback",
    "AGENTIC_THINKING" : "Pensando",
    "AGENTIC_AGENT_TITLE" : "Agente",
    "AGENTIC_COPILOT_MODE_TITLE" : "Modo Copiloto Agente",
    "AGENTIC_SENDING_MESSAGE" : "Enviando...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot está ouvindo ativamente sua conversa e pronto para assistir automaticamente",
    "AGENTIC_SEARCH_RESULTS" : "Resultados Agentes"
}